import cloneDeep from 'lodash/cloneDeep';
import { Md5 } from 'ts-md5';
import type { LevelData } from '../src/game/level/LevelData';
import { EMPTY_LEVEL } from '../src/game/level/EmptyLevel';
import { RAW_LEVELS } from './rawLevels';

export { RAW_LEVELS } from './rawLevels';

const minCycledLevel = 30;

export function getLevelData(levelIndex: number): LevelData {
  const adjustedIndex = getCycledLevelIndex(levelIndex);
  const rawLevelData: Partial<LevelData> = cloneDeep(RAW_LEVELS?.[adjustedIndex] || {});

  // remove tutorial after first cycle
  if (levelIndex > RAW_LEVELS.length - 1) {
    delete rawLevelData.tutorial;
  }

  return cloneDeep({ ...EMPTY_LEVEL, ...rawLevelData });
}

export function getLevelHash(levelIndex: number): string {
  const adjustedIndex = getCycledLevelIndex(levelIndex);
  return getLevelDataHash(RAW_LEVELS?.[adjustedIndex] ?? EMPTY_LEVEL);
}

export function getLevelDataHash(levelData: Partial<LevelData>): string {
  return Md5.hashStr(JSON.stringify(levelData));
}

export function getTotalLevels(): number {
  return RAW_LEVELS.length;
}

function getCycledLevelIndex(levelIndex: number): number {
  const totalLevels = getTotalLevels();
  if (levelIndex < totalLevels) return levelIndex;

  const levelsToCycle = totalLevels - minCycledLevel;
  const cycle = Math.floor((levelIndex - minCycledLevel) / levelsToCycle);
  return levelIndex - cycle * levelsToCycle;
}
